import { useEffect, useState } from "react";
import { Button, DatePicker, Input, Table, Spin, message } from "antd";
import dayjs from "dayjs";
import { ReloadOutlined, SearchOutlined } from "@ant-design/icons";
import type { ColumnsType } from "antd/es/table";
import locale from "antd/es/date-picker/locale/zh_CN";
import reconcile_icon from "@/images/service/reconcile_icon.png";
import empty_png from "@/images/empty.png";
import { useUserInfo } from "@/model";
import PreviewModal from "./components/PreviewModal";
import "./index.less";

import "dayjs/locale/zh-cn";
import { serviceApi } from "@/apis";

const Reconcile = () => {
  const userInfo = useUserInfo();
  const [loading, setLoading] = useState(false);

  const [tableData, setTableData] = useState<RecFindByConditionsItems[]>([]);
  // 搜索条件
  const [orderNum, setOrderNum] = useState("");
  const [orderTime, setOrderTime] = useState<any>("");

  // 表格信息
  const [curPage, setCurPage] = useState(1);
  const [total, setTotal] = useState(0);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [previewId, setPreviewId] = useState("");

  useEffect(() => {
    if (userInfo.curUserInfo) {
      handleSearch({
        customerUserCode: userInfo.curUserInfo.userAccount,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userInfo.curUserInfo]);

  const handleSearch = async (data: any = {}) => {
    try {
      setLoading(true);
      const reconciliationDate =
        orderTime && dayjs(orderTime).format("YYYY-MM");
      const res = await serviceApi.reconcile_findByConditions({
        customerUserCode: userInfo.curUserInfo?.userAccount,
        reconciliationDate,
        zvofac: orderNum,
        size: 20,
        page: curPage,
        ...data,
      });
      const { total, records } = res;
      setTotal(total);
      setTableData(records);
    } catch (error: any) {
      message.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleInquire = () => {
    setCurPage(1);
    handleSearch({ page: 1 });
  };

  const handleReset = () => {
    setOrderNum("");
    setOrderTime("");
    setCurPage(1);
    handleSearch({
      zvofac: "",
      reconciliationDate: "",
      page: 1,
    });
  };

  const changePage = (page: number) => {
    setCurPage(page);
    handleSearch({
      page,
    });
  };

  const openPreview = (record: RecFindByConditionsItems) => {
    setPreviewId(record.id);
    setIsModalOpen(true);
  };

  const columns: ColumnsType<RecFindByConditionsItems> = [
    {
      title: "对账月份",
      dataIndex: "reconciliationDate",
      key: "reconciliationDate",
    },
    {
      title: "对账单编号",
      dataIndex: "zvofac",
      key: "zvofac",
    },
    {
      title: "对账开始日期",
      dataIndex: "zfkdatl",
      key: "zfkdatl",
    },
    {
      title: "对账结束日期",
      dataIndex: "zfkdath",
      key: "zfkdath",
    },
    {
      title: "是否已读",
      dataIndex: "isRead",
      key: "isRead",
      render: (isRead) => <span>{isRead === "Y" ? "已读" : "未读"}</span>,
    },
    {
      title: "操作",
      key: "id",
      render: (_, record) => (
        // eslint-disable-next-line jsx-a11y/anchor-is-valid
        <a onClick={() => openPreview(record)}>下载对账函</a>
      ),
    },
  ];

  return (
    <div className="reconcile-wrapper">
      <div className="center-main-title">
        <img src={reconcile_icon} alt="" />
        <h3>对账函</h3>
      </div>
      <div className="reconcile-table-wrap">
        <Spin spinning={loading}>
          <article className="flex-b-c search-wrapper">
            <div className="flex">
              <Input
                value={orderNum}
                onChange={(e) => setOrderNum(e.target.value)}
                className="reconcile-number"
                allowClear
                placeholder="对账单编号"
              />
              <DatePicker
                placeholder="对账月份"
                value={orderTime}
                locale={locale}
                className="reconcile-time"
                onChange={(e: any) => setOrderTime(e)}
                picker="month"
              />
            </div>
            <div className="btns">
              <Button icon={<ReloadOutlined />} onClick={handleReset}>
                重置
              </Button>
              <Button
                className="inquire-btn"
                icon={<SearchOutlined />}
                type="primary"
                onClick={handleInquire}
              >
                查询
              </Button>
            </div>
          </article>
          <Table
            columns={columns}
            dataSource={tableData}
            className="reconcile-table"
            locale={{
              emptyText: (
                <div style={{ marginBottom: 30 }}>
                  <img src={empty_png} alt="暂无数据" />
                  <p>暂无数据</p>
                </div>
              ),
            }}
            pagination={{
              current: curPage,
              total,
              defaultPageSize: 10,
              onChange: changePage,
            }}
          />
        </Spin>
      </div>
      <PreviewModal
        previewId={previewId}
        isModalOpen={isModalOpen}
        setIsModalOpen={setIsModalOpen}
      />
    </div>
  );
};

export default Reconcile;
